import React from 'react';
import { columns } from './columns/index';
import { StyledContainer } from './styles';
import { FORM_SEARCH, searchDefaultValue } from './forms';
import { TextLarge, CardTheme } from '../../../components/index';
import { Icon } from '../../../resources';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';
import { ContainerButton } from '../../../styles/global-style';
import { useForm } from 'react-hook-form';
import { ResponsivePageLayout } from '../../../components/page-layout/ResponsivePageLayout';
import { useGetFrequency } from './hooks/useGetFrequency';
import { useGetFullFrequency } from './hooks/useGetFullFrequency';
import { SpaceBetween } from '../../manage-data/user-info/styles';
import { useEffect, useState } from 'preact/hooks';

export const ReportFrequency = () => {
  const [searchType, setSearchType] = useState(null);
  const formSearchObj = useForm({ defaultValues: searchDefaultValue });
  const {
    dataSource: historyData,
    onSearch,
    loading: isPendingFrequency,
  } = useGetFrequency({
    handleSubmit: formSearchObj.handleSubmit,
  });
  const {
    dataSource: fullHistoryData,
    onSearchFull,
    loading: isPendingFullFrequency,
  } = useGetFullFrequency({
    handleSubmit: formSearchObj.handleSubmit,
  });

  const onSearchByField = (values) => {
    if (values.search) {
      setSearchType('search');
      onSearchFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onSearch(values);
    }
  };

  useEffect(() => {
    onSearch(searchDefaultValue);
  }, []);

  const formSearch = FORM_SEARCH({ onEnter: formSearchObj.handleSubmit(onSearchByField) });
  return (
    <StyledContainer>
      <TextLarge text="รายงานความถี่การใช้คูปอง" />
      <CardTheme>
        <ResponsivePageLayout
          searchLayout={{
            title: 'ค้นหารายงานความถี่การใช้คูปอง',
            formSearch,
            useFormParam: formSearchObj,
            icon: <Icon.todo />,
            onSearch: formSearchObj.handleSubmit(onSearchByField),
            ignoreDateEmpty: true,
          }}
          tableLayout={{
            columns: columns(),
            dataSource: searchType === 'search' ? fullHistoryData : historyData,
            hasPagination: true,
            loading: isPendingFrequency || isPendingFullFrequency,
            extraContent: (
              <SpaceBetween>
                <ContainerButton right>
                  <ButtonExcelEmbedded
                    title="Export"
                    header={columns()}
                    data={searchType === 'search' ? fullHistoryData : historyData}
                    filename="รายงานความถี่การใช้คูปอง"
                  />
                </ContainerButton>
              </SpaceBetween>
            ),
          }}
        />
      </CardTheme>
    </StyledContainer>
  );
};
